/**
 * Carousel Component
 * @module patterns/components/banners/asset-hero-banner
 */

import { type App } from '~/app';

import JsController from '../../js-controller';

export default (app: App) => {

    const controller = new JsController(app, 'recipe-body');
    controller.addMountFunction(() => {
        mountComponent(controller);
    })

    return controller.init();
}

export function mountComponent( controller: JsController ) {
    const isMobileScreen = window.innerWidth <= 768 ? true : false;
    if(isMobileScreen){
        const recipeDetail = document.querySelector<HTMLElement>('.recipe-detail')
        const teaserTexts = recipeDetail?.querySelectorAll<HTMLElement>('.teaser-text')
        if(teaserTexts && teaserTexts.length>0){
            for(const currentTeaserText of teaserTexts){
                const readMoreButton = currentTeaserText.querySelector<HTMLElement>('.read-more-button')
                const readLessButton = currentTeaserText.querySelector<HTMLElement>('.read-less-button')
                const bodyText = currentTeaserText.querySelector<HTMLElement>('.body-text')
                if(readMoreButton && readLessButton && bodyText){
                //If the text is overflowing
                    if(bodyText.scrollHeight<=bodyText.offsetHeight)
                    {
                        readMoreButton?.classList.add('hidden')
                    }
                    else{
                        bodyText.classList.add("bottom-fade-mask");
                    }
        
                    const showFullText = () => {
                        if(!readMoreButton.classList.contains("hidden"))
                        {
                            readMoreButton.classList.add('hidden')
                        }

                        if(readLessButton.classList.contains("hidden"))
                        {
                            readLessButton.classList.remove('hidden')
                        }

                        if(!bodyText.classList.contains("!max-h-[unset]")){
                            bodyText?.classList.add("!max-h-[unset]");
                        }

                        if(bodyText.classList.contains("bottom-fade-mask")){
                            bodyText.classList.remove("bottom-fade-mask");
                        }
                    }

                    const hideFullText=()=>{

                        if(readMoreButton.classList.contains("hidden"))
                        {
                            readMoreButton.classList.remove('hidden')
                        }

                        if(!readLessButton.classList.contains("hidden"))
                        {
                            readLessButton.classList.add('hidden')
                        }

                        if(bodyText.classList.contains("!max-h-[unset]")){
                            bodyText?.classList.remove("!max-h-[unset]");
                        }
                    
                        if(!bodyText.classList.contains("bottom-fade-mask")){
                            bodyText.classList.add("bottom-fade-mask");
                        }
                    }

                    controller.addListener(readMoreButton, "click", showFullText)
                    controller.addListener(readLessButton, "click", hideFullText)
                }
            }
        }
    }
}
